import { HttpInterceptor,HttpHandler,HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import {MatDialog}from'@angular/material'
import{GlobalErrorComponent}from'../../global-error.component'
import { Injectable } from '@angular/core';
import{AdminAuthService}from'../../admin/services/admin-auth.service';
import {ScholarAuthService}from'../../scholar/services/scholar-auth.service'
import{MentorAuthService}from'../../mentor/services/mentor-auth.service'
import {Router}from'@angular/router'
@Injectable()
export class ErrorInterceptor implements HttpInterceptor{
    constructor(private matDialog:MatDialog,private router:Router,
        private adminAuthService:AdminAuthService,
        private scholarAuthService:ScholarAuthService,
        private mentorAuthService:MentorAuthService){
        
    }
    intercept(req:HttpRequest<any>,next:HttpHandler) {
        return next.handle(req).pipe(
            catchError((error:HttpErrorResponse)=>{
                if(error.status!==400){ 
                    if(error.status==401){
                        this.adminAuthService.logout()
                        this.mentorAuthService.logout()
                        this.scholarAuthService.logout()
                        this.router.navigate(['/'])
                    } 
                    else{
                        
                        const dialogRef=this.matDialog.open(GlobalErrorComponent,{width:'50%',height:'70%',data:error})
                        dialogRef.afterClosed().subscribe(result => {
                        });
                    }
                        
                }
                 return throwError(error)
               
            })
        )
    }

}